import styled from 'styled-components';

const BackgroundVideo = () => {
  return (
    <VideoWrapper>
      <video autoPlay loop muted playsInline>
        <source src="/videos/bg.mp4" type="video/mp4" />
        브라우저가 video를 지원하지 않습니다.
      </video>
      <OverlayContent>
        <h1>여기에 올 텍스트나 버튼</h1>
      </OverlayContent>
    </VideoWrapper>
  );
};

export default BackgroundVideo;

const VideoWrapper = styled.div`
  position: fixed; // ✅ 화면에 고정
  top: 0;
  left: 0;
  width: 100vw;
  height: 100vh;
  z-index: -1; // ✅ 아래에 깔기

  video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
`;

const OverlayContent = styled.div`
  position: relative;
  z-index: 1;
  color: white;
  text-align: center;
`;
